// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (1200px < width){.bc-table{grid-template-columns:minmax(33%,max-content) repeat(var(--compat-browser-count),calc(67%/var(--compat-browser-count)))}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
